@import '../../../globals/main.scss';

pn-find-price-result {
  .test {
    margin: 3em 0;
  }
}

.resultcontent {
  display: flex;
  // flex-wrap: wrap;
  // flex-direction: row;
  //align-items: flex-start;
  justify-content: center;
  flex-grow: 1;
}
